// IMPORTANT: Must be imported before any MUI5 or opensolar-ui imports.
// Configures MUI5 to use 'OSUI-' class name prefix instead of 'Mui' to avoid conflicts with MUI4.
// If this runs too late, MUI5 component styles (e.g. button colors) will silently break.
import 'opensolar-ui/src/utils/MUI5ClassNameGenerator'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import * as serviceWorker from './serviceWorker'

window.uxVersion = 3

// ReactDOM.render(
//   //@ts-ignore
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// )
const container = document.getElementById('root')!
const root = createRoot(container)
root.render(<App />)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
